import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Appstore from './../../../Images/appstore.png';
import Playstore from './../../../Images/playstore.png';
import homeSlider1 from "../../../../src/Images/New_Home/homeSlider1.png";
import CtaForm from "../../CtaForm/CtaForm"
import "./TradeRadarAlgoFbWelcome.css";
import { errorMonitor } from "stream";

function TraderadarAlgo() {
  return (
    <>
      <section id="bnrfrm" className="traderadarAlgo_section">
         <div class="container">
                  <div class="row align-items-center">
                      <div class="col-lg-6 col-md-12">
                      <div class="traderadarAlgo-conts">
                          <div class="banner-head fontNew">
                             Algo Trading Simplified
                          </div>
                           <p> Automate your Daily, Weekly, and monthly trading especially designed for working professionals </p>
                          </div>
                          <CtaForm></CtaForm>
                            <div class="traderadarAlgo-app">
                              <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241"><img src={Appstore}></img></a>
                              <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN"><img src={Playstore}></img></a>
                           </div>
                      </div>
                      <div class="col-lg-6 col-md-12">
                          <div class="img-container img-banner">
                              <img src={homeSlider1} alt="" class="img-fluid banner-5" />
                          </div>
                      </div>
                  </div>
           </div>
      </section>
     
    </>
  );
}
export default TraderadarAlgo;
